'use client';

import { ArrowRight } from 'lucide-react';
import { MagneticButton } from '@/components/shared/magnetic-button';

export function HeroCTAButton() {
  const handleClick = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <MagneticButton
      type="button"
      onClick={handleClick}
    >
      <span>Book a strategy call</span>
      <ArrowRight
        aria-hidden="true"
        strokeWidth={1.5}
        className="h-4 w-4 transition-transform duration-[var(--duration-base)] ease-[var(--ease-out)] group-hover:translate-x-0.5"
      />
    </MagneticButton>
  );
}
